module.exports = __webpack_public_path__ + "img/male-teenager-figure.e5e91667.svg";